import React from 'react';
import RoomClient from './RoomClient';

const RoomContext = React.createContext<RoomClient|undefined>(undefined);

export default RoomContext;
